import { solicitar } from '../identidad/cliente-identidad.js'
export interface ReporteGenerado {
  id: string
  nombre_archivo: string
  mime: string
  expira_en: string
  creado_en: string
}
export function generarReporte(tipo: string, filtros: { limite: number }) {
  return solicitar<ReporteGenerado>(`/api/v1/reportes/${tipo}`, {
    method: 'POST',
    body: JSON.stringify(filtros),
  })
}
